export default __webpack_public_path__ + "static/media/Punto_Benvenuto_ENG_Def.4d58932f.aac";